import { useEffect } from 'react';
import { useApolloClient, useSubscription } from '@apollo/client/react';
import { CreditUsageChangedDocument, CreditUsageDocument } from '@/graphql';
import { onSubscriptionsReconnected } from '@/services/subscription-reconnect';

/**
 * Writes every `creditUsageChanged` event into the cached `creditUsage`, so each reader updates
 * live, and refetches it after the socket reconnects. Mount once per session.
 */
export function useCreditUsageLive(): void {
  const client = useApolloClient();

  useSubscription(CreditUsageChangedDocument, {
    onData: ({ client: cache, data }) => {
      if (data.data === undefined) return;
      // `null` means the payer now bills by documents.
      cache.writeQuery({
        query: CreditUsageDocument,
        data: { creditUsage: data.data.creditUsageChanged }
      });
    }
  });

  useEffect(
    () =>
      onSubscriptionsReconnected(() => {
        void client.refetchQueries({ include: [CreditUsageDocument] });
      }),
    [client]
  );
}
